import React, { useState, useEffect, useRef } from 'react';
import styles from './ProgressiveImage.module.css';

export const toSrcSet = (variants) => variants.map(([src, width]) => `${src} ${width}w`).join(', ');

// Renders an entry from src/media/paintings (generated by `npm run images`):
// AVIF with a WebP fallback, sized by the browser from `sizes`, with a tiny
// blurred placeholder shown until the real image has loaded.
const ProgressiveImage = ({
    image,
    sizes,
    alt,
    isPriority = false,
    className = ''
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const imgRef = useRef(null);

    // A cached image can finish loading before React attaches onLoad
    useEffect(() => {
        if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
            setIsLoaded(true);
        }
    }, []);

    return (
        <div className={`${styles.container} ${className}`}>
            {/* Low-res placeholder - inlined in the bundle, heavily blurred */}
            <img
                src={image.placeholder}
                alt=""
                className={`${styles.image} ${styles.lowRes} ${isLoaded ? styles.hidden : ''}`}
                aria-hidden="true"
            />

            <picture className={styles.picture}>
                <source type="image/avif" srcSet={toSrcSet(image.avif)} sizes={sizes} />
                <img
                    ref={imgRef}
                    src={image.webp[0][0]}
                    srcSet={toSrcSet(image.webp)}
                    sizes={sizes}
                    width={image.width}
                    height={image.height}
                    alt={alt}
                    loading={isPriority ? 'eager' : 'lazy'}
                    fetchPriority={isPriority ? 'high' : 'auto'}
                    decoding="async"
                    onLoad={() => setIsLoaded(true)}
                    className={`${styles.image} ${styles.highRes} ${isLoaded ? styles.visible : ''}`}
                />
            </picture>
        </div>
    );
};

export default ProgressiveImage;
